// extracted by mini-css-extract-plugin
export var dropdown = "_t4-0";
export var imageWrapper = "_t4-3";
export var itemNameContainer = "_t4-1";
export var productImage = "_t4-2";
export var spinnerWrapper = "_t4-4";